import { io, Socket } from 'socket.io-client';

let socket: Socket | null = null;
let currentToken: string | null = null;

function createSocket(token?: string): Socket {
  const auth = token ? { token } : {};
  return io(process.env.REACT_APP_API_URL || '', { auth });
}

/**
 * Call this when the Auth0 token is available (right after reloadApiConfig).
 * Updates the socket's handshake auth so the gateway can authenticate therapist connections.
 */
export const reloadWsApi = (token: string): void => {
  currentToken = token;
  if (socket) {
    socket.auth = { token };
    socket.disconnect().connect();
  }
};

export const wsapi = (): Socket => {
  if (!socket) {
    socket = createSocket(currentToken ?? undefined);
  }
  return socket;
};

